import { VueController } from '../util/vue_controller'

// Connects to data-controller="item-verification-distributors"
export default class extends VueController {
  static outlets = ['form']

  static targets = ['grid']

  static values = {
    distributors: Array,
    existing: Array,
    name: {
      type: String,
      default: 'item_verification[distributor_ids]'
    }
  }

  static vueComponent = 'distributor-checks'

  get props () {
    return {
      distributors: this.distributorsValue,
      savedData: this.existingValue,
      fieldName: this.nameValue
    }
  }

  get vueTarget () {
    return this.gridTarget ?? super.vueTarget
  }

  handleEvent (eventName, data) {
    if (eventName === 'form-validity-changed') {
      if (data.isValid) {
        this.formOutlet.markAsValid()
      } else {
        this.formOutlet.markAsInvalid()
      }
    }
  }
}
